import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

/**
 * Modal shown when the idle timer reaches the warning threshold (2 min before expiry).
 *
 * Props:
 *   open          — controls visibility
 *   onStaySignedIn — called when the user clicks "Stay Signed In"
 *   onLogout       — called when the user clicks "Logout Now"
 */
const IdleWarningDialog = ({ open, onStaySignedIn, onLogout }) => (
  <Dialog
    open={open}
    onClose={onStaySignedIn}
    aria-labelledby="idle-warning-title"
    aria-describedby="idle-warning-description"
  >
    <DialogTitle id="idle-warning-title">Session About to Expire</DialogTitle>
    <DialogContent>
      <DialogContentText id="idle-warning-description">
        Your session will expire in 2 minutes due to inactivity. Do you want to stay signed in?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onLogout} color="error">
        Logout Now
      </Button>
      <Button onClick={onStaySignedIn} variant="contained" autoFocus>
        Stay Signed In
      </Button>
    </DialogActions>
  </Dialog>
);

export default IdleWarningDialog;
